import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
export default function delegateReducer(state = initialState.delegate, action) {
	switch (action.type) {
		case types.CREATE_DELEGATE: {
			return action.response;
		}
		case types.DELETE_DELEGATE: {
			return [];
		}
		default:
			return state;
	}
}